import { useCallback, useRef, useState } from 'react'
import {
  getPrograms,
  ProgramOverviewDto,
} from '../../../../infrastructure/api/programs'

type UseProgramDataReturn = {
  data: ProgramOverviewDto[]
  loading: boolean
  fetchPrograms: () => Promise<void>
}

export const useProgramData = (): UseProgramDataReturn => {
  const [data, setData] = useState<ProgramOverviewDto[]>([])
  const [loading, setLoading] = useState(false)
  const requestIdRef = useRef(0)

  const fetchPrograms = useCallback(async () => {
    const requestId = ++requestIdRef.current
    setLoading(true)
    try {
      const response = await getPrograms()
      if (requestId !== requestIdRef.current) return
      setData(response.json ?? [])
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false)
      }
    }
  }, [])

  return { data, loading, fetchPrograms }
}
